var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{attrs:{"color":_vm.color}},[_c('v-icon',{attrs:{"color":_vm.iconColor}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }